<template>
  <header class="header-bar">
    <div class="header-inner">
      <div class="header-left">
        <img class="header-logo"
          src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Cdefs%3E%3ClinearGradient id='g' x1='0%25' y1='0%25' x2='100%25' y2='100%25'%3E%3Cstop offset='0%25' stop-color='%235B7FFF'/%3E%3Cstop offset='100%25' stop-color='%237D5CFF'/%3E%3C/linearGradient%3E%3C/defs%3E%3Ccircle cx='16' cy='16' r='15' fill='url(%23g)'/%3E%3Ctext x='16' y='21' text-anchor='middle' fill='%23fff' font-size='12' font-weight='bold'%3EK%3C/text%3E%3C/svg%3E"
          alt="Klakna" />
        <span class="header-brand">Klakna</span>
      </div>
      <div class="header-right">
        <button class="connect-btn" @click="toggleWallet">Connect</button>
        <button class="menu-btn">☰</button>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderBar',
  methods: { toggleWallet() { this.$store.commit('SET_WALLET_VISIBLE', true) } }
}
</script>

<style scoped>
.header-bar {
  position: fixed; top: 0; left: 0; right: 0; z-index: 200;
  padding: 8px var(--s-4);  /* was 12px — match original 50px total */
  background: rgba(5,5,5,0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}
.header-inner {
  display: flex; justify-content: space-between; align-items: center;
  max-width: 430px; margin: 0 auto;
  height: 34px;  /* fixed height for consistency */
}
.header-left { display: flex; align-items: center; gap: var(--s-2); }
.header-logo { width: 24px; height: 24px; border-radius: var(--radius-sm); object-fit: contain; }
.header-brand { font-size: 16px; font-weight: 700; color: var(--text-primary); }
.header-right { display: flex; align-items: center; gap: var(--s-3); }
.connect-btn {
  height: 28px; padding: 0 14px;  /* was 34px/18px → match 29px total */
  background: var(--brand-gradient);
  border: none; border-radius: 14px;
  color: var(--text-primary);
  font-size: 11px; font-weight: 600;
  cursor: pointer;
  box-shadow: var(--glow-blue);
  transition: all var(--duration-fast);
}
.connect-btn:hover {
  box-shadow: 0 0 28px rgba(91,127,255,0.5);
  transform: translateY(-1px);
}
.menu-btn {
  background: none; border: none;
  font-size: var(--font-size-lg);
  color: rgba(255,255,255,0.8);
  cursor: pointer; padding: 0;
}
</style>
